var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 82 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2257 92.0207C42.7491 92.0207 47.639 89.975 54.6353 83.4589C65.7505 73.1544 78.7275 55.0457 78.7275 37.9979C78.7275 27.9202 74.7527 18.2553 67.6774 11.1293C60.6021 4.00333 51.006 0 41 0C30.994 0 21.3979 4.00333 14.3226 11.1293C7.24733 18.2553 3.27248 27.9202 3.27248 37.9979C3.27248 64.782 34.2482 91.4525 41.2257 92.0207ZM41 15.362C44.5561 15.362 48.0323 16.4241 50.9891 18.4139C53.9458 20.4037 56.2503 23.2319 57.6112 26.5408C58.972 29.8497 59.3281 33.4908 58.6343 37.0035C57.9406 40.5162 56.2282 43.7429 53.7136 46.2754C51.1991 48.808 47.9954 50.5327 44.5077 51.2314C41.0199 51.9301 37.4048 51.5715 34.1194 50.2009C30.834 48.8303 28.026 46.5093 26.0503 43.5313C24.0747 40.5534 23.0202 37.0522 23.0202 33.4707C23.0252 28.6695 24.9211 24.0664 28.2918 20.6715C31.6626 17.2765 36.233 15.3671 41 15.362ZM82 95.5818C82 99.124 67.5372 106 41 106C14.4628 106 0 99.124 0 95.5818C0 93.2141 6.77064 88.8195 21.8541 86.5465C22.1162 86.5048 22.3701 86.4217 22.6064 86.3002C29.678 93.0247 36.5991 97.3435 40.7743 97.6655H41.3009C46.9431 97.6655 55.1619 90.6758 58.472 87.6072C58.8858 87.2284 59.2995 86.8116 59.7133 86.3949C59.8551 86.4414 59.9996 86.4794 60.1459 86.5086C75.2294 88.8195 82 93.2141 82 95.5818Z",
    fill: "#09AC53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneLogo);
export default __webpack_public_path__ + "static/media/zoneLogo.0d5d617c.svg";
export { ForwardRef as ReactComponent };